// ** Reducers Imports
import layout from './layout';
import navbar from './navbar';
import auth from './authenticate';

const rootReducer = { navbar, layout, auth };

export default rootReducer;
